import { Seo } from "../components/Seo";
import { CollectionCard } from "../components/CollectionCard";
import { JewelleryMotif } from "../components/JewelleryMotif";
import { site } from "../config/site";
import { collections } from "../data/collections";

export function HomePage() {
  return (
    <>
      <Seo title={site.brandName} path="/" />
      <main id="main">
        <section className="hero">
          <div className="hero-inner">
            <div>
              <p className="kicker">Coming soon</p>
              <h1>Jewellery for everyday moments</h1>
              <hr className="hero-rule" />
              <p className="lede">
                A collection of rings, necklaces, earrings and bracelets is on its way.
              </p>
              <p className="quiet-note">Shopping is not available yet.</p>
            </div>
            <div className="hero-art">
              <JewelleryMotif motif="necklace" />
            </div>
          </div>
        </section>
        <div className="page">
          <section className="section" aria-labelledby="collections-heading">
            <div className="section-head">
              <div>
                <p className="kicker">The collection</p>
                <h2 id="collections-heading">Rings, necklaces, earrings and bracelets</h2>
              </div>
            </div>
            <div className="collection-rail">
              {collections.map((collection) => (
                <CollectionCard key={collection.slug} collection={collection} />
              ))}
            </div>
          </section>
        </div>
      </main>
    </>
  );
}
